/**
 * @module geo/actions/creators
 *
 */
import {ClearService} from '../application/clear.service';
import {PendingService} from '../../types/services/pending.service';
import {actionCreator} from '../helpers/actions.creator.builder';
import {ActionCreator} from '../helpers/fsa';
import {TypeKeyActionsProxy} from '../types.key.actions.proxy';
import {TypeKeyActions} from '../types.key.action';
import { ApplicationAvailable } from '../application/application.available';

/**
 * Return an action to register a service in pending state
 * @internalapi
 */
 const pendingServiceCreator =
    actionCreator<PendingService>(TypeKeyActionsProxy.PENDING_SERVICE) as
    ActionCreator<PendingService>;
/**
 * Return an action to clear a Service.
 */
 const clearServiceCreator =
    actionCreator<ClearService>(TypeKeyActions.CLEAR_SERVICE) as
    ActionCreator<ClearService>;
const ApplicationAvailableCreator=
    actionCreator<ApplicationAvailable>(TypeKeyActionsProxy.APPLICATION_AVAILABLE)

export {clearServiceCreator, pendingServiceCreator,ApplicationAvailableCreator}

